const roles = {
  admin: 'Administrators',
  manager: 'Managers',
  users: 'Users',
  customer: 'ROLE_CUSTOMER',
}

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    if (hasAuthor(roles.admin)) {
      return '/handle-system.html'
    } else if (hasAuthor(roles.user)) {
      return '/handle-system.html'
    } else {
      return '/handle-system.html'
    }
  },

  authorizationMapper: [
    // {
    //   regex: /^\/welcome.html\/.*/,
    //   isAuthorized: function (hasAuthor) {
    //     return hasAuthor(roles.admin)
    //   }
    // },
    {
      regex: /^\/welcome.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.admin) || hasAuthor(roles.customer)
      }
    },
    {
      regex: /^\/.*\/story.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.admin)|| hasAuthor(roles.customer)
      }
    },
    {
      regex: /^\/play-game.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.admin)|| hasAuthor(roles.customer)
      }
    },
    {
      regex: /^\/handle-system.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.admin)|| hasAuthor(roles.customer)
      }
    },
    {
      regex: /^\/challenges.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.admin)|| hasAuthor(roles.customer)
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/security/config.js